import { TEMPLATE } from '../../config';
import NewIek from './new-iek';
import NewItk from './new-itk';
import Oni from './oni';

export interface TemplateProps {
    hasPendingRequests: boolean;
}

const templates = {
    new_iek: NewIek,
    new_itk: NewItk,
    oni: Oni,
};

const TemplateComponent = templates[TEMPLATE as keyof typeof templates];
if (!TemplateComponent) {
    throw new Error('Некорректный шаблон каталога: ' + TEMPLATE);
}
export default TemplateComponent;
